var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"maskClosable":false,"visible":_vm.visible,"title":("确认要删除“" + (_vm.record.name) + "”吗？"),"confirmLoading":_vm.confirmLoading,"destroyOnClose":""},on:{"ok":_vm.save,"cancel":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }